export default __webpack_public_path__ + "static/icons-right-6d43e4afcb207fd9f095c9125fffce63.png";